import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { getInitialOfferingData, cancelBuyOrder } from '../../services/InitialOfferings/initialOfferingSection';
import { toastNotify } from '../../utils/toastNotify';
import { addOrRemoveToFavourite } from '../../services/FavoriteAPI';
const initialState = {
  loading: true,
  loadingMore: false,
  cancelBuyOrderLoading: false,
  sliderData: {},
  webData: {},
  mobileData: {},
  isUpdating: false,
};
export const fetchInitialOfferingListAction = createAsyncThunk('FETCH_INITIAL_OFFERING_LIST', getInitialOfferingData);
export const fetchInitialOfferingWebListAction = createAsyncThunk('FETCH_INITIAL_OFFERING_WEB_LIST', getInitialOfferingData);
export const fetchInitialOfferingMobileListAction = createAsyncThunk('FETCH_INITIAL_OFFERING_MOBILE_LIST', getInitialOfferingData);
export const fetchMoreInitialSliderAction = createAsyncThunk('FETCH_MORE_INITIAL_SLIDER', getInitialOfferingData);
export const fetchInfiniteInitialAction = createAsyncThunk('FETCH_INFINITE_INITIAL', getInitialOfferingData);
export const cancelBuyOrderAction = createAsyncThunk('CANCEL_BUY_ORDER', cancelBuyOrder);
export const addOrRemoveToFavouriteAction = createAsyncThunk('ADD_OR_REMOVE_FAV', addOrRemoveToFavourite);

export const initialOfferingSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  reducers: {
    updateInitialPropertyList: (state, action) => {
      state.sliderData = { ...action.payload };
    },
    updateWebInitialPropertyList: (state, action) => {
      state.webData = { ...action.payload };
    },
    updateMobileInitialPropertyList: (state, action) => {
      state.mobileData = { ...action.payload };
    },
  },
  extraReducers: {
    [fetchInitialOfferingListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchInitialOfferingListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        sliderData: action.payload,
        webData: action.payload,
        mobileData: action.payload,
      };
    },
    [fetchInitialOfferingListAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching web initial page data
    [fetchInitialOfferingWebListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchInitialOfferingWebListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        webData: action.payload,
      };
    },
    [fetchInitialOfferingWebListAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching mobile data
    [fetchInitialOfferingMobileListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchInitialOfferingMobileListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        mobileData: {
          ...current(state.mobileData),
          data: { ...current(state.mobileData.data), properties: current(state.mobileData.data.properties).concat(action.payload.data.properties) },
        },
      };
    },
    [fetchInitialOfferingMobileListAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    [fetchInfiniteInitialAction.pending]: (state) => {
      return { ...state, loadingMore: true };
    },
    [fetchInfiniteInitialAction.rejected]: (state) => {
      return { ...state, loadingMore: false };
    },
    [fetchInfiniteInitialAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loadingMore: false,
        webData: {
          ...current(state.webData),
          data: {
            ...current(state.webData.data),
            currentPage: action.payload.data.currentPage,
            properties: current(state.webData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },

    [fetchMoreInitialSliderAction.fulfilled]: (state, action) => {
      return {
        ...state,
        sliderData: {
          ...current(state.sliderData),
          data: {
            ...current(state.sliderData.data),
            properties: current(state.sliderData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },

    [cancelBuyOrderAction.pending]: (state, action) => {
      return {
        ...state,
        cancelBuyOrderLoading: true,
      };
    },
    [cancelBuyOrderAction.fulfilled]: (state, action) => {
      return {
        ...state,
        cancelBuyOrderLoading: false,
      };
    },
    [cancelBuyOrderAction.rejected]: (state, action) => {
      return {
        ...state,
        cancelBuyOrderLoading: false,
      };
    },

    //favourity part
    [addOrRemoveToFavouriteAction.pending]: (state, action) => {
      return {
        ...state,
        isUpdating: true,
      };
    },
    [addOrRemoveToFavouriteAction.fulfilled]: (state, action) => {
      return {
        ...state,
        isUpdating: false,
      };
    },
    [addOrRemoveToFavouriteAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        isUpdating: false,
      };
    },
  },
});

export const { updateInitialPropertyList, updateWebInitialPropertyList, updateMobileInitialPropertyList } = initialOfferingSlice.actions;
const { reducer } = initialOfferingSlice;
export default reducer;
